import { CommissionSlider } from "./commission-slider";
import { OfferFormT } from "./types";
import { useAuth } from "../../../../../../../public/auth/infrastructure/store/auth-context";
import { useGetOrderByMovement } from "../../../../services";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import React, { Fragment, useEffect, useMemo } from "react";

export const OfferComission = (): React.ReactElement => {
  const { control, setValue } = useFormContext<OfferFormT>();
  const { user } = useAuth();

  const [order, rate] = useWatch({
    control,
    name: ["order", "rate"],
  });

  const { data } = useGetOrderByMovement(order?.movementNumber ?? "", {
    enabled: !!order?.movementNumber,
  });

  const totalCharge = useMemo(
    () => data?.data?.total_charge ?? undefined,
    [data]
  );

  const { max, min } = useMemo<{
    max: number;
    min: number;
  }>(
    () => ({
      max: Math.floor(totalCharge || 0 * 0.8),
      min: -Math.ceil(totalCharge || 0 * 0.8),
    }),
    [totalCharge]
  );

  const margin = useMemo(
    () => (totalCharge ?? 0) - (rate ?? 0),
    [totalCharge, rate]
  );

  useEffect(() => {
    const value = (margin - 95) * 0.1;
    const commission = Math.round(value * 10) / 10;
    setValue("commission", commission >= 0 ? commission : 0);
  }, [margin, setValue]);

  return user?.dispatch_division?.country !== "Colombia" ? (
    <section className="mt-[10px] grid gap-[10px]">
      <Controller
        name="commission"
        render={({ field: { value } }) => (
          <CommissionSlider
            name="commission"
            min={min}
            max={max}
            value={margin}
            commission={(value as number) ?? null}
            onChange={(_, value) => {
              if (totalCharge) {
                setValue("rate", Math.round(totalCharge - value));
              }
            }}
            disabled={!rate || rate < 1 || !totalCharge}
          />
        )}
      />
    </section>
  ) : (
    <Fragment />
  );
};
